"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/MessageTemplates/SaveAsTemplateModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _common = require('shared/selectors/blobject/common');
var _conversation = require('shared/selectors/conversation');
var _useChatTemplateContext = require('shared/hooks/templates/useChatTemplateContext');
var _templateResolver = require('shared/services/templateResolver');
var _useTemplateBlanks = require('shared/hooks/templates/useTemplateBlanks');
var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');

var _TemplateEditorModal = require('./TemplateEditorModal'); var _TemplateEditorModal2 = _interopRequireDefault(_TemplateEditorModal);









const Editor = ({
  text, conversationKey, senderName, onClose, orgKey, blobjectKey,
}) => {
  const { showSuccessBar } = _noticeBar.useNoticeBar.call(void 0, )
  // The same values (and sending team) the picker inserts with, so Preview agrees.
  const context = _useChatTemplateContext.useChatTemplateContext.call(void 0, orgKey, blobjectKey)
  const blanks = _useTemplateBlanks.useTemplateBlanks.call(void 0, {
    orgKey, conversationKey, text, staffName: senderName, onlyOnePatient: !!_templateResolver.onlyPatient.call(void 0, context),
  })
  return (
    _react2.default.createElement(_TemplateEditorModal2.default, {
      orgKey: orgKey,
      draft: { Name: '', Body: blanks.body },
      blanks: blanks,
      previewContext: context,
      onClose: onClose,
      onSaved: t => showSuccessBar(`Saved "${t.Name}" as a template`), __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}
    )
  )
}

/* Opens the template editor on a sent message. The sender's name and the
 * chat's only patient's names start swapped for variables; the other details
 * that look patient-specific are offered as blanks. */
const SaveAsTemplateModal = props => {
  const blobjectKey = _hooks.useAppSelector.call(void 0, state => _optionalChain([_common.selectBlobjectByWrappedKey.call(void 0, state, props.conversationKey), 'optionalAccess', _ => _.Key]))
  const orgKey = _hooks.useAppSelector.call(void 0, state => blobjectKey ? _conversation.selectMyOrgKeyInConvo.call(void 0, state, blobjectKey)  : null)
  if (!orgKey || !blobjectKey) return null
  return _react2.default.createElement(Editor, { ...props, orgKey: orgKey, blobjectKey: blobjectKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}} )
}

exports. default = SaveAsTemplateModal
